export const RESET = 'USERDATAADDRESS_UPDATE_RESET'
export const SET_ERROR = 'USERDATAADDRESS_UPDATE_SET_ERROR'
export const SET_RETRIEVED = 'USERDATAADDRESS_UPDATE_SET_RETRIEVED'
export const SET_UPDATED = 'USERDATAADDRESS_UPDATE_SET_UPDATED'
export const SET_VIOLATIONS = 'USERDATAADDRESS_UPDATE_SET_VIOLATIONS'
export const TOGGLE_LOADING = 'USERDATAADDRESS_UPDATE_TOGGLE_LOADING'
export const UPDATE_RETRIEVED = 'USERDATAADDRESS_UPDATE_UPDATE_RETRIEVED'
